export default __webpack_public_path__ + "static/media/upload-button-background-image.2c04be2f.png";